import { connect } from "react-redux";
import { getBrandDisplayName, getShowPfsMessage } from "app/reducers/partnerSelector";
import SocialBar from "./SocialBar";

const mapStateToProps = state => {
	return {
		resolution: state.resolution,
		partnerData: state.partnerData,
		brandDisplayName: getBrandDisplayName(state),
		showPfsMessage: getShowPfsMessage(state),
	};
};

export default connect(mapStateToProps)(SocialBar);
